import React from "react";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { FaGooglePlay } from "react-icons/fa";
import Tilt from "react-parallax-tilt";

function ProjectCards(props) {
  const contentCol = (
    <Col md={6} className="project-content-col" style={{ display: "flex", flexDirection: "column", justifyContent: "center", textAlign: "left", padding: "20px 40px" }}>
      <h2 style={{ fontWeight: "700", marginBottom: "20px", color: "white" }}>{props.title}</h2>
      <p className="project-card-description">
        {props.description}
      </p>
      <div style={{ marginTop: "20px" }}>
        <Button 
          variant="primary" 
          href={props.ghLink} 
          target="_blank" 
          style={{ 
            marginRight: "15px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 8px 15px rgba(129, 72, 144, 0.4)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.1)";
          }}
        >
          {props.isPlayStore ? <FaGooglePlay /> : <BsGithub />} &nbsp;
          {props.isPlayStore ? "Play Store" : props.isBlog ? "Blog" : "GitHub"}
        </Button>
        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ 
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 8px 15px rgba(129, 72, 144, 0.4)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.1)";
            }}
          >
            <CgWebsite /> &nbsp;
            {"Demo"}
          </Button>
        )}
      </div>
    </Col>
  );

  const imageCol = (
    <Col md={6} className="project-image-col" style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px" }}>
      {props.lightImage && props.darkImage ? (
        <div style={{ position: "relative", width: "100%", display: "flex", justifyContent: "center", gap: "15px", alignItems: "center" }}>
           <div style={{ width: "45%", position: "relative" }}>
             <img 
               src={props.lightImage} 
               alt="light-mode" 
               style={{ 
                 width: "100%", 
                 borderRadius: "10px", 
                 boxShadow: "0 10px 30px -15px rgba(0,0,0,0.8)", 
                 transition: "all 0.3s ease", 
                 cursor: "pointer" 
               }} 
               onMouseOver={(e) => {
                 e.currentTarget.style.transform = "scale(1.05)";
                 e.currentTarget.style.boxShadow = "0 15px 30px rgba(129, 72, 144, 0.5)";
               }} 
               onMouseOut={(e) => {
                 e.currentTarget.style.transform = "scale(1)";
                 e.currentTarget.style.boxShadow = "0 10px 30px -15px rgba(0,0,0,0.8)";
               }} 
             />
           </div>
           <div style={{ width: "45%", position: "relative" }}>
             <img 
               src={props.darkImage} 
               alt="dark-mode" 
               style={{ 
                 width: "100%", 
                 borderRadius: "10px", 
                 boxShadow: "0 10px 30px -15px rgba(0,0,0,0.8)", 
                 transition: "all 0.3s ease", 
                 cursor: "pointer" 
               }} 
               onMouseOver={(e) => {
                 e.currentTarget.style.transform = "scale(1.05)";
                 e.currentTarget.style.boxShadow = "0 15px 30px rgba(129, 72, 144, 0.5)";
               }} 
               onMouseOut={(e) => {
                 e.currentTarget.style.transform = "scale(1)";
                 e.currentTarget.style.boxShadow = "0 10px 30px -15px rgba(0,0,0,0.8)";
               }} 
             />
           </div>
        </div>
      ) : (
        <img 
          src={props.imgPath} 
          alt="project-img" 
          style={{ 
            maxWidth: "100%", 
            maxHeight: "350px", 
            borderRadius: "10px", 
            boxShadow: "0 10px 30px -15px rgba(0,0,0,0.8)", 
            transition: "all 0.3s ease", 
            cursor: "pointer" 
          }} 
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "scale(1.05)";
            e.currentTarget.style.boxShadow = "0 15px 30px rgba(129, 72, 144, 0.5)";
          }} 
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0 10px 30px -15px rgba(0,0,0,0.8)";
          }} 
        />
      )}
    </Col>
  );

  return (
    <Tilt
      tiltMaxAngleX={4}
      tiltMaxAngleY={4}
      perspective={1000}
      scale={1.01}
      transitionSpeed={1200}
      glareEnable={true}
      glareMaxOpacity={0.12}
      glareColor="#ffffff"
      glarePosition="all"
      glareBorderRadius="20px"
    >
      <div className="project-card-view">
        <Row className={props.isReversed ? "flex-md-row-reverse" : ""}>
          {imageCol}
          {contentCol}
        </Row>
      </div>
    </Tilt>
  );
}

export default ProjectCards;
